import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export let EIntegratorLastSyncStatus;
(function (EIntegratorLastSyncStatus) {
  EIntegratorLastSyncStatus["Success"] = "success";
  EIntegratorLastSyncStatus["Failure"] = "failure";
  EIntegratorLastSyncStatus["NeedsSync"] = "needs-sync";
  EIntegratorLastSyncStatus["InProgress"] = "in-progress";
  EIntegratorLastSyncStatus["ForceSync"] = "force-sync";
})(EIntegratorLastSyncStatus || (EIntegratorLastSyncStatus = {}));
export const fieldsIntegrator = _extends({}, fieldsIBaseModel, {
  credentials: {
    type: 'Unknown'
  },
  enabled: {
    type: 'Boolean'
  },
  integratorClient: {
    type: 'ID',
    ref: EModel.IntegratorClient
  },
  lastSuccessfulSync: {
    type: 'Date'
  },
  lastSync: {
    type: 'Date'
  },
  lastSyncStatus: {
    type: 'Option',
    values: EIntegratorLastSyncStatus
  },
  setting: {
    type: 'ID',
    ref: EModel.Setting
  },
  settings: {
    type: 'Object'
  },
  type: {
    type: 'Option',
    values: EExternalSource
  }
});